import { render, staticRenderFns } from "./VentasListaItemProductos.vue?vue&type=template&id=5ba20657&"
import script from "./VentasListaItemProductos.vue?vue&type=script&lang=js&"
export * from "./VentasListaItemProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports